import React, { forwardRef, useEffect, useImperativeHandle } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import EditIcon from "@mui/icons-material/Edit";
import EditTableModal from "./EditTableModal";
import { useDispatch, useSelector } from "react-redux";
import { Column, nutritionColumnDef, NewNutritionColumnDef } from "./Columns";
import MuiPagination from "@mui/material/Pagination";
import { TablePaginationProps } from "@mui/material/TablePagination";
import {
  DataGrid,
  GridColDef,
  GridPagination,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  gridPageCountSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import { Alert, AlertProps, Snackbar } from "@mui/material";
import {
  handleAddNewRow,
  AddOrDeleteColumn,
  processingRowUpdate,
} from "../../Utils/rowUtils";
import ConfirmDeleteModal from "../../Components/Common/ConfirmDeleteModal";

const NutritionManufacturingMasterTables = forwardRef(
  (props: any, ref: any) => {
    const selectedUsecaseId = useSelector(
      (state: any) => state.InputDataReducers.selectedUsecaseId
    );
    const selectedCategoryId = useSelector(
      (state: any) => state.InputDataReducers.selectedCategoryId
    );

    /**Redux state */
    const selectedFolderId = useSelector(
      (state: any) => state.InputDataReducers.selectedFolderId
    );

    const selectedScenarioId = useSelector(
      (state: any) => state.InputDataReducers.selectedScenarioId
    );

    const isEditEnabled = useSelector(
      (state: any) => state.InputDataReducers.editFilterEnable
    );
    const columns: GridColDef[] = NewNutritionColumnDef;
    const dispatch: any = useDispatch();
    // const [rows, setRows] = React.useState([]);
    const [confirmDelete, setConfirmDelete] = React.useState(false);
    const [deleteRowId, setDeleteRowId] = React.useState({ id: "" });
    const [isProcessed, setIsProcessed] = React.useState(false);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [isOpenEditModal, setIsOpenEditModal] = React.useState(false);
    const [editedData, setEditedData] = React.useState({});
    const [updatedVal, setUpdatedVal] = React.useState<any>(editedData);
    const [resetValues, setResetValues] = React.useState({ capacity: 0 });
    const [getEditedTableData, setEditedTableData] = React.useState<any>([]);
    const { dashboardSummaryCost, isDone, isLoading, uploadMasterFileMessage } =
      useSelector((state: any) => state.InputDataReducers);

    useImperativeHandle(ref, () => ({
      ClearEditedData() {
        setEditedTableData([]);
      },
    }));

    useEffect(() => {
      setIsProcessed(props.isProcessed);
      // setRows(props.rowsData);
      props.handleGetEditData(getEditedTableData);
    }, [props.rowsData, getEditedTableData]);

    const handleChangePage = (event: unknown, newPage: number) => {
      setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: any) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
    };

    const handleEditMaster1TableRow = (e: any, row: any) => {
      setResetValues({ capacity: row?.capacity });
      setIsOpenEditModal(true);
      setEditedData(row);
    };

    const handleChangeEditValue = (e: any) => {
      setUpdatedVal({
        ...editedData,
        ...updatedVal,
        [e.target.name]: e.target.value,
      });
    };

    const UpdateTableRow = () => {};

    const closeEditModal = (e: any) => {
      setIsOpenEditModal(false);
    };

    const handleClickOpenDeleteModal = (id: any) => {
      setDeleteRowId(id);
      setConfirmDelete(true);
      // deleteInMainId = id;
    };

    const handleCloseDelete = () => {
      setConfirmDelete(false);
      // deleteInMainId = "";
    };

    const handleonDelete = () => {
      if (deleteRowId) {
        props.setRows((prev: any[]) => {
          const rowToDelete = prev.find((row) => row.id === deleteRowId.id);
          if (rowToDelete) {
            const updatedRow = {
              ...rowToDelete,
              folder_id: 0,
              folder_Id: 0,
              scenario_id: 0,
            };

            setEditedTableData((prevEditedData: any[]) => [
              ...prevEditedData,
              updatedRow,
            ]);

            return prev.filter((row) => row.id !== deleteRowId);
          }

          return prev; // If no row is found, return the previous rows
        });
        console.log(getEditedTableData, "editedtabledata");
      }

      // Close the delete confirmation modal
      setConfirmDelete(false);
      setDeleteRowId({ id: "" });
    };
    // bulk edit
    const [snackbar, setSnackbar] = React.useState<Pick<
      AlertProps,
      "children" | "severity"
    > | null>(null);
    const handleCloseSnackbar = () => setSnackbar(null);

    const processRowUpdate = (newRow: any) => {
      processingRowUpdate(newRow, getEditedTableData, setEditedTableData);
    };

    const tableColumns: GridColDef[] = [
      {
        field: "factory_Code",
        headerName: "Factory Code",
        width: 130,
        align: "left",
        headerAlign: "left",
        editable: isEditEnabled,
        headerClassName: "super-app-theme--cell-header",
        cellClassName: "super-app-theme--cell-normal",
        sortable: false,
        // flex: 1,
      },
      {
        field: "factory",
        headerName: "Factory",
        width: 130,
        align: "left",
        headerAlign: "left",
        editable: isEditEnabled,
        headerClassName: "super-app-theme--cell-header",
        cellClassName: "super-app-theme--cell-normal",
        sortable: false,
        flex: 1,
      },
      {
        field: "format",
        headerName: "Format",
        width: 130,
        align: "left",
        headerAlign: "left",
        editable: isEditEnabled,
        headerClassName: "super-app-theme--cell-header",
        cellClassName: "super-app-theme--cell-normal",
        sortable: false,
        flex: 1,
      },
      {
        field: "cascade",
        headerName: "Cascade",
        width: 130,
        align: "left",
        headerAlign: "left",
        editable: isEditEnabled,
        headerClassName: "super-app-theme--cell-header",
        cellClassName: "super-app-theme--cell-normal",
        sortable: false,
        flex: 1,
      },
      {
        field: "product",
        headerName: "Product",
        width: 130,
        align: "left",
        headerAlign: "left",
        editable: isEditEnabled,
        headerClassName: "super-app-theme--cell-header",
        cellClassName: "super-app-theme--cell-normal",
        sortable: false,
        flex: 1,
      },
      {
        field: "capacity",
        headerName: "Capacity",
        width: 130,
        align: "left",
        headerAlign: "left",
        editable: isEditEnabled,
        headerClassName: "super-app-theme--cell-header",
        cellClassName: "super-app-theme--cell",
        sortable: false,
        flex: 1,
        preProcessEditCellProps(params) {
          const invalid =
            params.props.value === null || params.props.value === ""
              ? true
              : false;
          if (invalid) {
            setSnackbar({
              children: "Please enter a valid number!",
              severity: "error",
            });
          }
          return { ...params.props, error: invalid };
        },
      },
      {
        field: "actions",
        headerName: "Action",
        sortable: false,
        width: 150,
        renderCell: (params: any) => {
          return AddOrDeleteColumn(
            params,
            props,
            isEditEnabled,
            handleClickOpenDeleteModal,
            handleAddNewRow
          );
        },
      },
    ];

    const tableData = {
      columns: tableColumns,
      rows: props.rowsData,
      initialState: {
        columns: {
          columnVisibilityModel: {
            id: false,
          },
        },
      },
      experimentalFeatures: {
        ariaV7: true,
      },
    };

    function Pagination({
      page,
      onPageChange,
      className,
    }: Pick<TablePaginationProps, "page" | "onPageChange" | "className">) {
      const apiRef = useGridApiContext();
      const pageCount = useGridSelector(apiRef, gridPageCountSelector);

      return (
        <MuiPagination
          color="primary"
          className={className}
          count={pageCount}
          page={page + 1}
          onChange={(event, newPage) => {
            onPageChange(event as any, newPage - 1);
          }}
        />
      );
    }

    function CustomPagination(props: any) {
      return <GridPagination ActionsComponent={Pagination} {...props} />;
    }

    const MyCustomNoRowsOverlay = () => (
      <div className="nodata-display-lable">No Data to Display.</div>
    );

    return (
      <>
        {isOpenEditModal && (
          <EditTableModal
            isOpen={isOpenEditModal}
            editedData={editedData}
            resetValues={resetValues}
            UpdateTableRow={UpdateTableRow}
            onClose={closeEditModal}
            handleChangeEditValue={handleChangeEditValue}
            headerName="Manufacturing Master Table"
          />
        )}
        {confirmDelete && (
          <ConfirmDeleteModal
            confirmDelete={confirmDelete}
            handleCloseDelete={handleCloseDelete}
            handleOnDelete={handleonDelete}
          />
        )}
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <DataGrid
            processRowUpdate={processRowUpdate}
            editMode="row"
            {...tableData}
            density="compact"
            {...(isEditEnabled && { checkboxSelection: true })}
            checkboxSelectionWidth={50}
            sx={{
              "& .MuiDataGrid-checkboxInput": {
                width: "30px", // Set the width of the checkbox itself
              },
              "& .MuiDataGrid-columnHeader--checkbox": {
                width: "50px", // Set the width of the checkbox column header
                minWidth: "50px", // Ensure the column doesn't shrink below this width
              },
              "& .MuiDataGrid-cell--checkbox": {
                width: "50px", // Set the width of the checkbox column cells
                minWidth: "50px",
              },
            }}
            rowSelectionModel={props.selectedRows || []}
            onRowSelectionModelChange={(newSelection: any) => {
              props.handleSelectionChange(newSelection);
            }}
            initialState={{
              ...tableData.initialState,
              pagination: { paginationModel: { pageSize: 10 } },
            }}
            pageSizeOptions={[10, 25, 50, 100]}
            showColumnVerticalBorder
            showCellVerticalBorder
            pagination
            slots={{
              pagination: CustomPagination,
              noRowsOverlay: MyCustomNoRowsOverlay,
              //toolbar: CustomToolbar,
            }}
            disableColumnSelector
            hideFooterSelectedRowCount
            disableRowSelectionOnClick
          />
        </Paper>
        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </>
    );
  }
);

export default NutritionManufacturingMasterTables;
